import { ImageOff } from "lucide-react";

export function ProductPlaceholder({ className = "", label = "Photo coming soon" }) {
  return (
    <div className={`flex flex-col items-center justify-center gap-2 bg-gradient-to-br from-slate-100 to-slate-200 text-slate-400 ${className}`}>
      <ImageOff className="h-8 w-8" />
      <span className="font-spec text-[11px] uppercase tracking-wider">{label}</span>
    </div>
  );
}
